import {SortablePaginationModuleConfiguration} from "./sortable-pagination.module-configuration";
import {SortablePaginationComponent} from "./component/sortable-pagination/sortable-pagination.component";
import {SortingOrderComponent} from "./component/orederingComponent/sorting-order.component";

SortablePaginationModuleConfiguration.createNewModule()
    .component('sortablePagination', SortablePaginationComponent.instance)
    .component('sortingOrder', SortingOrderComponent.instance)
;